import type { ComponentProps } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { BodyM } from '@sorare/core/src/atoms/typography';
import { Ellipsis } from '@sorare/core/src/atoms/typography/Ellipsis';
import { SocialShare } from '@sorare/core/src/components/user/SocialShare';
import { useEvents } from '@sorare/core/src/lib/events/useEvents';
import { glossary } from '@sorare/core/src/lib/glossary';

const Root = styled(Horizontal)`
  background-color: var(--c-nd-100);
  padding: var(--unit);
  border-radius: var(--unit);
  max-width: 500px;
`;

const ReferralLinkAddress = styled(Ellipsis)`
  color: var(--c-white);
  flex-grow: 1;
`;

type Props = {
  shareUrl: string;
  buttonsSize: ComponentProps<typeof Button>['size'];
  shareMessage?: string;
};

export const ReferralLink = ({
  shareUrl,
  buttonsSize,
  shareMessage,
}: Props) => {
  const track = useEvents();
  const copyToClipboardAndTrack = () => {
    navigator.clipboard.writeText(shareUrl);
    track('Share Duo Mission', {});
  };
  return (
    <Root>
      <ReferralLinkAddress>{shareUrl}</ReferralLinkAddress>
      {!!navigator.clipboard && (
        <Button
          size={buttonsSize}
          color="transparent"
          onClick={copyToClipboardAndTrack}
        >
          <BodyM bold>
            <FormattedMessage {...glossary.copy} />
          </BodyM>
        </Button>
      )}
      <SocialShare
        url={shareUrl}
        title="share"
        message={shareMessage}
        trackingEventName="Share Duo Mission"
        trackingEventContext="Missions Page"
        renderButton={({ ShareButton, label }) => (
          <ShareButton color="primary" size={buttonsSize}>
            {label}
          </ShareButton>
        )}
      />
    </Root>
  );
};
